import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Scale, Check, Plus, X } from "lucide-react";

export const useCompareSelect = (max = 3) => {
  const [ids, setIds] = useState([]);
  const toggle = (id) => setIds((x) => (x.includes(id) ? x.filter((v) => v !== id) : x.length < max ? [...x, id] : x));
  return { ids, toggle, clear: () => setIds([]) };
};

export const CompareToggle = ({ id, sel }) => {
  const on = sel.ids.includes(id);
  const full = !on && sel.ids.length >= 3;
  return (
    <button type="button" data-testid={`compare-toggle-${id}`} disabled={full} onClick={() => sel.toggle(id)} title={full ? "You can compare up to 3" : ""}
      className={`h-9 px-3 rounded-lg text-xs font-bold border inline-flex items-center gap-1.5 transition-colors disabled:opacity-40 ${on ? "bg-[#1E293B] text-white border-[#1E293B]" : "border-slate-300 text-slate-600 hover:border-[#10B981]"}`}>
      {on ? <Check className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}{on ? "Added" : "Compare"}
    </button>
  );
};

export const CompareTray = ({ sel, type, names }) => {
  const nav = useNavigate();
  if (!sel.ids.length) return null;
  return (
    <>
    <div className="h-24" aria-hidden="true" />
    <div data-testid="compare-tray" className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:left-auto z-40 sm:w-[440px] rounded-2xl bg-[#0F172A] text-white shadow-2xl p-4 flex items-center gap-3 animate-in slide-in-from-bottom-4">
      <Scale className="w-6 h-6 text-amber-300 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold">{sel.ids.length}/3 selected</p>
        <p data-testid="compare-tray-names" className="text-xs text-slate-400 truncate">{sel.ids.map((id) => names[id] || id).join(" vs ")}</p>
      </div>
      <button data-testid="compare-tray-clear" onClick={sel.clear} className="p-2 text-slate-400 hover:text-white" aria-label="Clear"><X className="w-4 h-4" /></button>
      <button data-testid="compare-tray-go" disabled={sel.ids.length < 2} onClick={() => nav(`/compare?type=${type}&ids=${sel.ids.join(",")}`)}
        className="h-10 px-4 rounded-xl bg-[#10B981] hover:bg-[#059669] text-[#0F172A] text-sm font-bold disabled:opacity-50 transition-colors">{sel.ids.length < 2 ? "Add 1 more" : "Compare now"}</button>
    </div>
    </>
  );
};
